import styled from 'styled-components/macro';
import { ThemedComponent } from '@la/ds-ui-components';
import { getCursorProperty } from '../utils/drag';

export const MemberOption = styled.li<{
  $height?: number;
  $hideOverflow?: boolean;
  $selectable?: boolean;
  $selected?: boolean;
}>(({ $height, $hideOverflow, $selectable, $selected }) => ({
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  height: $height ?? 'auto',
  margin: 0,
  padding: 0,
  borderRadius: '4px',
  overflow: $hideOverflow ? 'hidden' : 'visible',
  cursor: getCursorProperty($selected, $selectable),
}));

export const DragOverlay = styled.div<ThemedComponent<{ $height?: number }>>(
  ({ $height, theme }) => ({
    background: theme.foundational.blueGrey[50],
    width: '100%',
    height: $height ?? 'auto',
    position: 'absolute',
    top: '0',
    left: '0',
    border: '8px solid transparent',
    borderRadius: '4px',
    pointerEvents: 'none',
  })
);
